import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccordionV2 from '../../layout/AccordionV2';

const PermissionCategoryAccordion = ({
  title,
  children,
  count,
  total,
}: {
  title: ReactNode;
  children: ReactNode;
  count: number;
  total: number;
}) => (
  <AccordionV2
    title={(
      <Box display="flex" justifyContent="space-between" width="100%">
        <Typography fontSize="1rem" color="primary">
          {title}
        </Typography>
        <Typography>
          {count}
          {' '}
          /
          {' '}
          {total}
        </Typography>
      </Box>
    )}
    bgColorSummary="greenGray"
  >
    {children}
  </AccordionV2>
);

export default React.memo(PermissionCategoryAccordion);
